export default {
  namespaced: true,
  state() {
    return {
      character: "gg",
      towerId: -1,
      floorId: 0,
      floor: null,
      power: 5,
      hasBonus: false,

      destination: null,

      state: "none" // none, movingIn, movingOut
    };
  },
  mutations: {
    setPosition(state, payload) {
      state.towerId = payload.towerId;
      state.floorId = payload.floorId;

      state.floor = payload.floor;
    },
    setPower(state, payload) {
      state.power = payload.power;
      state.hasBonus = payload.hasBonus;
    },
    setState(state, payload) {
      state.state = payload.state;
    },
    setDestination(state, destination) {
      state.destination = destination;
    }
  },
  actions: {
    move({ state, commit }, payload) {
      if (state.state === "none") {
        commit("setDestination", payload);
        commit("setState", { state: "movingIn" });
      } else {
        commit("setPosition", state.destination);
        commit("setState", { state: "movingOut" });
      }
    },
    fight({ state, commit }) {
      commit(
        "updateFloorState",
        {
          towerId: state.towerId,
          floorId: state.floorId,
          state: "fight"
        },
        { root: true }
      );
    }
  }
};
